/**
 * THE canonical origin of the public website — one constant, imported by everything that writes a
 * URL a search engine or AI crawler will read (canonical links, Open Graph, JSON-LD, the sitemap,
 * llms.txt, the Markdown mirrors).
 *
 * WHY THIS FILE EXISTS. Two separate SEO modules used to each declare their own origin, and they
 * disagreed: `src/site/lib/seo.ts` said greenbaybio.com while `src/lib/seo/config.ts` (and the
 * static <head> in index.html, robots.txt and sitemap.xml) said bio.airmax.co.in. The live site
 * therefore served, on EVERY url, a `<link rel="canonical">` pointing at a DIFFERENT host — an
 * instruction to search engines to index that other host instead of this one — and a sitemap that
 * listed only that other host's urls. Whatever ranking greenbaybio.com earned was being handed away.
 *
 * greenbaybio.com is the canonical host: it is the brand domain, it is what the marketing site's own
 * SITE_URL already defaulted to, and it is what the sitemap generator already defaulted to.
 * bio.airmax.co.in still answers and must be 301-redirected here at the server (see
 * infra/nginx/greenbaybio.conf) — a duplicate origin cannot be fixed from inside the bundle.
 *
 * Override per environment with VITE_SITE_URL (no trailing slash needed — one is stripped).
 */
export const SITE_URL = (import.meta.env.VITE_SITE_URL || 'https://greenbaybio.com').replace(/\/+$/, '');

/** Resolve a site-relative path (or pass through an already-absolute url) to an absolute url. */
export function absoluteUrl(path = '/'): string {
  if (/^https?:\/\//i.test(path)) return path;
  return `${SITE_URL}${path.startsWith('/') ? '' : '/'}${path}`;
}
